import React, { useCallback, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { useVariables } from '../../../providers/VariableProvider'
import AsOfDatePicker from '../DenaliDataPipeline/asOfDatePicker'
import CustomDatePicker from '../DenaliDataPipeline/customDatePicker'
import { HideWhen, ShowWhen } from '../DenaliDataPipeline/when'
import { useAppContext } from '../../../redux/slices/appContext'
import PipelineQuickDatePicker from './quickDatePicker'
import CustomRangeDialog from './CustomRangeDialog'

const EXPECTED_VALUE_CUSTOM = 'custom'

function TransactionDates ({
  asOfDateVariable,
  dateRangeVariable,
  startDateVariable,
  endDateVariable
}) {
  const {
    getVariable,
    setVariable
  } = useVariables()
  const { availableDates } = useAppContext()
  const dateRangeValue = getVariable(dateRangeVariable)
  const [dialogIsOpen, setDialogIsOpen] = useState(dateRangeVariable === 'custom')

  const closeDialog = useMemo(() => {
    return () => setDialogIsOpen(false)
  }, [setDialogIsOpen])

  const onSave = useCallback((value) => {
    setVariable(startDateVariable, value?.startDate)
    setVariable(endDateVariable, value?.endDate)
    closeDialog()
  }, [endDateVariable, setVariable, startDateVariable, closeDialog])

  const onClose = useCallback(() => {
    closeDialog()
  }, [closeDialog])

  const onChangeDate = useCallback((value) => {
    if (value === 'custom' && !dialogIsOpen) {
      setDialogIsOpen(true)
    }
  }, [setDialogIsOpen, dialogIsOpen])

  useEffect(() => {
    if (getVariable(startDateVariable) === undefined) {
      setVariable(startDateVariable, availableDates.mainDate)
    }

    if (getVariable(endDateVariable) === undefined) {
      setVariable(endDateVariable, availableDates.mainDate)
    }
  }, [availableDates.mainDate, dateRangeValue, endDateVariable, getVariable, setVariable, startDateVariable])

  return (
    <>
      <PipelineQuickDatePicker applyTo={dateRangeVariable} includeCustom onChange={onChangeDate} />
      <HideWhen applyTo={dateRangeVariable} expectedValue={EXPECTED_VALUE_CUSTOM}>
        <AsOfDatePicker applyTo={asOfDateVariable} />
      </HideWhen>
      <ShowWhen applyTo={dateRangeVariable} expectedValue={EXPECTED_VALUE_CUSTOM}>
        <CustomDatePicker startDateVariable={startDateVariable} endDateVariable={endDateVariable} />
      </ShowWhen>
      <CustomRangeDialog onSave={onSave} open={dialogIsOpen} onClose={onClose} />
    </>
  )
}

TransactionDates.propTypes = {
  asOfDateVariable: PropTypes.string,
  dateRangeVariable: PropTypes.string,
  startDateVariable: PropTypes.string,
  endDateVariable: PropTypes.string
}

TransactionDates.defaultProps = {
  asOfDateVariable: 'asOfDate',
  dateRangeVariable: 'dateRange',
  startDateVariable: 'startDate',
  endDateVariable: 'endDate'
}

export default TransactionDates
